import { FieldDefinition, FieldBuilder, MENU_CATEGORY_KEY, MENU_NAME_SUFFIX, MENU_SUBCATEGORY_KEY, MenuCategories, MenuSubcategories } from '@zendra/shared';
import { NurseryActivityParameterService } from '../proxy/controlling/controllers/nursery-activity-parameter.service';
import { LocationService } from '@planning/proxy/planning/controllers/location.service';

FieldBuilder.setNamespace('Controlling');

export const ACTIVITYPERNURSERY_FIELDS: FieldDefinition[] = [
  FieldBuilder
    .foreignKey('nurseryActivityParameterId', 'Entity.NurseryActivityParameter', NurseryActivityParameterService)
    .required()
    .display('process.name') 
    .keyField('id')
    .hideInChildForms()
    .build(),
  FieldBuilder // TODO: when the orchestrator is implemented, refactor this nested logic into it
    .foreignKey('locationId', 'Entity.ActivityPerNursery.Location', LocationService)
    .required()
    .display('name') 
    .keyField('id') 
    .build(),
];

export const ACTIVITYPERNURSERY_CONFIG = {
  entityName: 'ActivityPerNursery',
  localizationKey: 'Controlling::Entity.ActivityPerNursery',
  fields: ACTIVITYPERNURSERY_FIELDS,
  permission: 'ControllingActivities.ActivityPerNurseries',
  showInMenu: true,
  menuCategory: MENU_CATEGORY_KEY + MenuCategories.Controlling + MENU_NAME_SUFFIX,
  menuSubcategory: MENU_SUBCATEGORY_KEY + MenuSubcategories.Activities + MENU_NAME_SUFFIX,
};
